import { useQuery } from "@tanstack/react-query";
import adminApiClient, { MapBounds } from "../../../api/admin";

const STALE_TIME = 5 * 60 * 1000;
const CACHE_TIME = 10 * 60 * 1000;
const MAX_RETRY_DELAY = 30000;

const WORLD_BOUNDS: MapBounds = {
  northEast: { lat: 90, lng: 180 },
  southWest: { lat: -90, lng: -180 },
};

const createBoundsKey = (bounds: MapBounds): string => {
  const { northEast, southWest } = bounds;
  return `${northEast.lat.toFixed(4)},${northEast.lng.toFixed(4)},${southWest.lat.toFixed(4)},${southWest.lng.toFixed(4)}`;
};

export function useTopCollections(
  bounds: MapBounds,
  limit: number,
  enabled: boolean,
  global: boolean = false,
) {
  const effectiveBounds = global ? WORLD_BOUNDS : bounds;
  const boundsKey = createBoundsKey(effectiveBounds);

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["top-collections", global ? "global" : boundsKey, limit],
    queryFn: () => adminApiClient.getTopCollections(effectiveBounds, limit),
    enabled,
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
    retry: 2,
    retryDelay: (attemptIndex) =>
      Math.min(1000 * 2 ** attemptIndex, MAX_RETRY_DELAY),
  });

  return {
    topCollections: data?.collections ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
    error: error as Error | null,
  };
}
